import { Tabs } from "antd";
import { useState } from "react";
import Catalogue from "./Catalogue";
import ServiceBox from "./ServiceBox";
import Suppliers from "./Suppliers";
import History from "./History";
import "./neopartslink.scss";

const { TabPane } = Tabs;

const NeopartsLink = () => {
  const [activeKey, setActiveKey] = useState("catalogue");
  const [compareRef, setCompareRef] = useState(null);
  const [requestedSearch, setRequestedSearch] = useState(null);

  const handleCompare = (ref) => {
    setCompareRef({ value: ref, tick: Date.now() });
    setActiveKey("suppliers");
  };

  const handleReopen = (search) => {
    setRequestedSearch({ ...search, tick: Date.now() });
    setActiveKey("catalogue");
  };

  return (
    <div className="npl-page">
      <div className="npl-header-row">
        <div>
          <h1 className="npl-title">NeopartsLink</h1>
          <p className="npl-subtitle">
            Catalogue de pièces d'origine, Service Box et comparateur
            fournisseurs
          </p>
        </div>
      </div>
      <div className="npl-card" style={{ padding: "4px 20px 0" }}>
        <Tabs
          className="npl-tabs"
          activeKey={activeKey}
          onChange={setActiveKey}
          destroyOnClose
        >
          <TabPane tab="Catalogue" key="catalogue">
            <div style={{ margin: "16px -4px 0" }}>
              <Catalogue
                onCompare={handleCompare}
                requestedSearch={requestedSearch}
              />
            </div>
          </TabPane>
          <TabPane tab="Service Box" key="servicebox">
            <div style={{ margin: "16px -4px 0" }}>
              <ServiceBox />
            </div>
          </TabPane>
          <TabPane tab="Fournisseurs" key="suppliers">
            <div style={{ margin: "16px -4px 0" }}>
              <Suppliers initialRef={compareRef} />
            </div>
          </TabPane>
          <TabPane tab="Historique" key="history">
            <div style={{ margin: "16px -4px 0" }}>
              <History onReopen={handleReopen} />
            </div>
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

export default NeopartsLink;
export { Catalogue, ServiceBox, Suppliers, History };